import { InternationalWireTransferAccountValidationTopBanner } from 'modules/app/layout/components/InternationalWireTransferAccountValidationTopBanner/InternationalWireTransferAccountValidationTopBanner';
import { MissingKycInformationBanner } from 'modules/app/layout/components/MissingKycInformationBanner/MissingKycInformationBanner';
import { Supervision } from 'src/core/common/components/Supervision/Supervision';
import { OverdueInvoiceNotification } from 'src/core/modules/billing/OverdueInvoiceNotification/OverdueInvoiceNotification';
import { PriceUpdateNotification } from 'src/core/modules/billing/PriceUpdateNotification/PriceUpdateNotification';

import styles from './TopBanners.module.css';
import { DelegationHeader } from '../DelegationHeader/DelegationHeader';
import { HeaderLoadNotif } from '../HeaderLoadNotif/HeaderLoadNotif';

export const TopBanners = () => {
  return (
    <div className={styles.container}>
      <OverdueInvoiceNotification />
      <Supervision />
      <HeaderLoadNotif />
      <DelegationHeader />
      <MissingKycInformationBanner />
      <InternationalWireTransferAccountValidationTopBanner />
      <PriceUpdateNotification />
    </div>
  );
};
